import React from 'react'
import PropTypes from 'prop-types'

import ModalWizard from 'components/modal_wizard'
import { routerShape } from 'react-router/lib/PropTypes'
import { withRouter } from 'react-router'
import Confetti from 'components/common/confetti'

import { exitGlimpse, isForward } from 'lib/glimpse'

class EditGlimpse extends React.Component {
  static propTypes = {
    operatingRemotely: PropTypes.bool,
    children: PropTypes.any,
    routes: PropTypes.array.isRequired,
    params: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    router: routerShape.isRequired,
    route: PropTypes.any,
    progressValue: PropTypes.number,
    goalReached: PropTypes.bool,
  }

  handleClose = () => {
    exitGlimpse('edit', this.props.router)
  }

  render() {
    const child = React.Children.only(this.props.children)
    const stepName = this.props.routes[this.props.routes.length - 1].path
    const isDelete = stepName === 'delete'
    return (
      <ModalWizard
        movingForward={isForward(this.props.location)}
        hideBack={this.props.params.hideBack}
        glimpse={true}
        showSpinner={!isDelete && this.props.operatingRemotely}
        onClose={this.handleClose}
        background={
          stepName === 'manage' && this.props.goalReached ? Confetti : undefined
        }
        route={this.props.route}
      >
        {React.cloneElement(child, { key: stepName })}
      </ModalWizard>
    )
  }
}

export default withRouter(EditGlimpse)
